<!-- 创建检修结果 -->
<template>
  <div class="createResult business-content-main">
    <div class="scroll-view">
      <div class="bread-nav">
        <breadcrumb :canBackHistory="true"></breadcrumb>
      </div>
      <el-form :model="formData" :rules="rules" ref="formData" label-width="150px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="车主：" style="margin-bottom:0px;"><div style="padding-left:10px;">{{CarModel.RName}}</div></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话：" style="margin-bottom:0px;"><div style="padding-left:10px;">{{CarModel.RPhone}}</div></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="车牌：" style="margin-bottom:0px;"><div style="padding-left:10px;">{{CarModel.CarNum}}</div></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车架号码：" style="margin-bottom:0px;"><div style="padding-left:10px;">{{CarModel.VehicleCode}}</div></el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="6">
              <el-form-item label="车型：" style="margin-bottom:0px;"><div style="padding-left:10px;">{{CarModel.CarDesc}}</div></el-form-item>
            </el-col>
          <el-col :span="6">
            <el-form-item label="预约类型：" style="margin-bottom:0px;">
              <div style="padding-left:10px;">{{CarModel.ReservationType== 0?'到店检修':CarModel.ReservationType== 1?'上门检修':'公路救援'}}</div>
              </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="车型"><div style="padding-left:10px;">{{CarModel.CarDesc}}</div></el-form-item> -->

        <!-- 提车时间、推送车主功能暂时剔除 -->
        <!-- <div style="display:flex;">
          <el-form-item label="可提车日期" prop="_PickUpCarDate">
            <el-date-picker
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions0"
              size="small"
              v-model="formData._PickUpCarDate"
              placeholder="选择日期"
              @change="changePickUpCarDate(formData._PickUpCarDate)"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="form-timer-picker" prop="_PickUpCarTime">
            <el-time-picker
              :picker-options="pickerOptions1"
              size="small"
              v-model="formData._PickUpCarTime"
              type="datetime"
              format="HH:mm"
              value-format="HH:mm:ss"
              placeholder="选择时间"
            ></el-time-picker>
          </el-form-item>
        </div> -->
        <!-- <el-form-item label="推送给车主">
          <el-switch v-model="formData.IsPush" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item> -->
        <el-form-item label="检修结果：" prop="Results" style="margin-top: 24px">
          <div style="height: 200px">
            <!-- <quillEditor v-model="formData.Results" ref="myQuillEditor" :options="editorOption"></quillEditor> -->
           <el-input type="textarea" placeholder="请输入内容" v-model="formData.Results" maxlength="500" :rows="8" show-word-limit></el-input>
          </div>
        </el-form-item>
        <el-form-item label="维修建议：" prop="name">
          <div>
            <el-button class="btn-primary" icon="el-icon-plus" size="small" @click="showDialog">新增配件</el-button>
          </div>
          <div class="pj-list">
            <el-card
              class="box-card"
              v-for="(item,index) in formData.AutoPartsList"
              :key="index"
              style="margin-bottom: 20px"
            >
              <div class="pj-item">
                <i class="el-icon-remove remove-pj" title="删除" @click="removePj(index)"></i>
                <div class="image-ctn" v-if="item.Source!=3">
                  <img
                    :src="item.MainImg ? downloadUrl + item.MainImg+'?imageView2/2/w/200' : ''"
                    alt=""
                    class="pj-cover"
                    :onerror="defaultImg"
                  >
                </div>
                <div v-else>
                  <uploadFile :pjIndex="index" :defaultImg="item.MainImg" type="AutoParts" @uploadSuccess="uploadSuccess"></uploadFile>
                </div>
                <div class="pj-input-ctn" v-if="item.Source!=3">
                  <p>配件名称</p>
                  <el-input
                    type="text"
                    size="small"
                    v-model="item.GoodName"
                    style="width: 200px"
                    disabled
                  ></el-input>
                </div>
                <div class="pj-input-ctn" v-else>
                  <p>配件名称</p>
                  <el-input type="text" size="small" v-model="item.GoodName" style="width: 200px"></el-input>
                </div>
                <div class="pj-input-ctn">
                  <p>数量</p>
                  <p>
                    <el-input-number size="small" v-model="item.Count" :min="1" :max="10" step-strictly @input="handlerTotalPrice"></el-input-number>
                  </p>
                </div>
                <div class="pj-input-ctn">
                  <p>配件价格(元)</p>
                  <p>
                    <el-input
                      type="number"
                      step="0.01"
                      min="0"
                      size="small"
                      v-model="item.ShopPrice"
                      @input="handlerTotalPrice"
                    ></el-input>
                  </p>
                </div>
                <div class="pj-input-ctn">
                  <p>安装费用（元）</p>
                  <p>
                    <el-input
                      type="number"
                      step="0.01"
                      min="0"
                      size="small"
                      v-model="item.InstallationFee"
                      @input="handlerTotalPrice"
                    ></el-input>
                  </p>
                </div>
                <!-- <div class="pj-input-ctn border-right">
                  <p>优惠金额（元）</p>
                  <p>
                    <el-input
                      type="number"
                      step="0.01"
                      min="0"
                      size="small"
                      v-model="item.Discount"
                    ></el-input>
                  </p>
                </div> -->
                <div class="pj-input-ctn" style="width: 150px">
                  <p>总价（元）</p>
                  <p>{{item | handlePrice}}</p>
                </div>
              </div>
            </el-card>
            <div class="money-msg">
              <div>
                <div class="money-item">
                    <span class="key">配件总额：</span>
                    <span class="value">￥{{OrderAmount}}</span>
                </div>
                <!-- <div class="money-item">
                    <span class="key">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠：</span>
                    <span class="value">￥{{DiscountsMoney}}</span>
                </div> -->
                <div class="money-item all-money">
                    <span class="key">总价格：</span>
                    <span class="value font-md">￥{{PaymentAmount}}</span>
                </div>
                </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="ops-ctn">
        <el-button
          class="btn-primary"
          size="small"
          @click="submitRepairRecords"
          :disabled="saveBtndisabled"
        >提交</el-button>
        <el-button size="small" @click="back()" style="margin-right:170px;">取消</el-button>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="新增配件"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        width="880px"
      >
        <div style="padding-top: 20px">
          <choosePJ @choosePJ="choosePJ" ref="choosePJ"></choosePJ>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// import { quillEditor } from "vue-quill-editor";
import quillConfig from "../../../assets/js/quill-config";
import choosePJ from "@/components/business/msgSetting/choosePJ";
import uploadFile from "@/components/common/uploadFileGrid.vue";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    // quillEditor,
    choosePJ,
    uploadFile,
    breadcrumb
  },
  data() {
    let now = this.$util.getNowFormatTime();
    let userMsg= this.$util.getLocalStorage("userMsg");
    return {
      needConfirm:true,
      canRequest:true,
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions1: {
        selectableRange: `${now}:00 - 23:59:59`
      },
      pageTitle: "创建检修结果",
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      dialogVisible: false,
      editorOption: quillConfig, // 富文本编辑器配置
      formData: {
        RId: "",
        Results: "", // 富文本编辑器内容
        IsPush: true,
        // _PickUpCarDate: "",
        // _PickUpCarTime: "",
        // PickUpCarTime: "",
        Operator: userMsg.Account,
        EntpId: userMsg.EntpId,
        UId: "",
        AutoPartsList: []
      },
      OrderAmount: 0,
      DiscountsMoney: 0,
      PaymentAmount: 0,
      CarModel: {},
      rules: {
        // _PickUpCarTime: [
        //   { required: true, message: "可提车时间必填", trigger: "blur" }
        // ],
        // _PickUpCarDate: [
        //   { required: true, message: "可提车日期必填", trigger: "blur" }
        // ],
        Results: [{ required: true, message: "检修结果必填", trigger: "blur" }]
      },
      saveBtndisabled: false //保存按钮是否禁用
    };
  },
  filters: {
    handlePrice(item) {
      let result =
        item.Count * item.ShopPrice +
        Number(item.InstallationFee) -
        Number(item.Discount);
      if (result && result > 0) {
        return result.toFixed(2) * 1;
      } else {
        return 0;
      }
    }
  },
  beforeRouteLeave(to,from,next){
    this.$util.confirmBeforeLeave(to, from, next, this);
  },
  mounted() {
    this.formData.RId = this.$route.query.RId;
    this.formData.UId = this.$route.query.UId;
    this.formData.RecordId = this.$route.query.RecordId;
    if (this.formData.RecordId) {
      this.pageTitle = "编辑检修结果";
      this.getRepairRecords(this.formData.RecordId,this.formData.RId);
    }else{
       this.getRepairRecords('',this.formData.RId);
    }
  },
  methods: {
    // 计算总价
    handlerTotalPrice(){
        let that = this;
        let apList= [...that.formData.AutoPartsList];
        let _OrderAmount=0;
        let _DiscountsMoney=0;
        let _InstallationFee=0;
        if(!apList||apList.length==0){
            that.OrderAmount=0;
            that.DiscountsMoney=0;
            that.PaymentAmount=0;
        }else{
            for(let i=0;i<apList.length; i++){
              _InstallationFee+=Number(apList[i].InstallationFee);
              _OrderAmount+=Number(apList[i].Count*apList[i].ShopPrice);
              _DiscountsMoney+=Number(apList[i].Discount);
            }
             that.OrderAmount=_OrderAmount.toFixed(2) * 1;
             that.DiscountsMoney=_DiscountsMoney.toFixed(2) * 1;
             that.PaymentAmount=(that.OrderAmount+_InstallationFee).toFixed(2) * 1;
        }
    },
    // 上传商品图片回调
    uploadSuccess(url, index) {
      this.formData.AutoPartsList[index].MainImg=url+'?imageView2/2/w/200';
    },
    //获取检修结果
    getRepairRecords(recordId,rid) {
      this.$util
        .axiosGet({
          url: "/api/CustomerManagement/GetRepairRecords",
          data: { recordId: recordId,rid: rid}
        })
        .then(res => {
          let data = res.data.data;
          if (res.data.errcode == 0 && data) {
            this.CarModel=data.CarModel;
            // this.formData._PickUpCarDate = data.PCarDate;
            // this.formData._PickUpCarTime = data.PCarTime;
            this.formData.Results = data.Results;
            this.formData.IsPush = data.IsPush;
            let _auto = data.AutoPartsList;
            _auto.forEach(item => {
              item.GoodName = item.Cn;
              item.MainImg = item.goodsImg;
            });
            this.formData.AutoPartsList = _auto;
          } else {
            this.saveBtndisabled = true;
            this.$util.errorMsg(data.errmsg);
          }
        }).catch(() => {});
    },
    // 提交检修结果
    submitRepairRecords() {
      let AutoPartsList = this.formData.AutoPartsList;
      if (!AutoPartsList[0]) {
        this.$util.warningMsg("请添加汽配件");
        return;
      }
      for (let i = 0; i < AutoPartsList.length; i++) {
        if (AutoPartsList[i].GoodName == "") {
          this.$util.warningMsg("请输入商品名称！");
          return;
        }
        if (AutoPartsList[i].ShopPrice <= 0 ) {
          AutoPartsList[i].ShopPrice = 0;
          this.$util.warningMsg("配件价格不能小于等于零！");
          return;
        }
        if (AutoPartsList[i].Discount < 0) {
          AutoPartsList[i].Discount = 0;
          this.$util.warningMsg("优惠不能小于零！");
          return;
        }
        if (
          AutoPartsList[i].ShopPrice * AutoPartsList[i].Count +
            AutoPartsList[i].InstallationFee <
          AutoPartsList[i].Discount
        ) {
          this.$util.warningMsg("优惠不能大于配件价格！");
          return;
        }
        if (AutoPartsList[i].InstallationFee < 0) {
          AutoPartsList[i].InstallationFee = 0;
          this.$util.warningMsg("安装费用不能小于零！");
          return;
        }
      }
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.saveBtndisabled = true;
          // this.formData.PickUpCarTime = this.formData._PickUpCarDate + " " + this.formData._PickUpCarTime;
          this.formData.CarbarnId=this.CarModel.CarbarnId;
          if (!this.canRequest){
            return;
          }
          this.canRequest = false
          this.$util
            .axiosPost({
              url: "/api/CustomerManagement/SubmitRepairRecords",
              data: this.formData
            })
            .then(res => {
              if (res.errcode == 0) {
                this.needConfirm = false
                this.$util.successMsg("提交成功");
                setTimeout(() => {
                  this.canRequest = true
                  // this.$router.push(`/repairMamage/reservation`);
                  this.$store.commit("updateNeedRefresh", true);
                  window.history.go(-1);
                }, 2000);
              } else {
                this.canRequest = true
                this.$util.errorMsg(res.errmsg);
                this.saveBtndisabled = false;
              }
            })
            .catch(err => {
              this.canRequest = true
              this.saveBtndisabled = false;
            });
        }
      });
    },
    // 取消 直接返回上一页
    back() {
      window.history.back(-1);
    },
    // 处理弹窗关闭
    handleClose() {
      this.$refs.choosePJ.clearDataAndClose();
    },
    // 删除配件
    removePj(index) {
      this.formData.AutoPartsList.splice(index, 1);
    },
    // 选PJ
    choosePJ(params) {
      if (!params) {
        this.dialogVisible = false;
        return;
      }
      let target = this.formData.AutoPartsList;
      let addData = params;
      if (!target[0]) {
        this.formData.AutoPartsList = [...addData, ...target];
        if (addData[0].GoodId) {
          this.$refs.choosePJ.clearDataAndClose();
        }
        return;
      }
      if (addData) {
        let needAppend = [];
        for (let i = 0; i < addData.length; i++) {
          // 直接创建的配件
          if (addData[i].GoodId == "") {
            needAppend.push(addData[i]);
            this.formData.AutoPartsList = [...target, ...needAppend];
            return;
          }
          let flag = false;
          for (let j = 0; j < target.length; j++) {
            if (target[j].GoodId == addData[i].GoodId) {
              target[j].Count += 1;
              flag = false;
              break;
            } else {
              flag = true;
            }
          }
          if (flag) {
            needAppend.push(addData[i]);
          }
        }
        this.formData.AutoPartsList = [...target, ...needAppend];
        this.$refs.choosePJ.clearDataAndClose();
      }
      this.dialogVisible = false;
    },
    // 显示dialog
    showDialog() {
      this.dialogVisible = true;
    },
    onEditorChange({ quill, html, text }) {
      this.formData.Results = html;
    },
    // 日期选择时对时间做处理
    changePickUpCarDate(value) {
      let nowData = this.$util.getNowFormatDate();
      let nowTime = this.$util.getNowFormatTime();
      if (nowData === value) {
        this.pickerOptions1 = {
          selectableRange: `${nowTime}:00 - 23:59:59`
        }
        this.formData._PickUpCarTime = `${nowTime}:00`
      } else {
        this.pickerOptions1 = {
          selectableRange: `00:00:00 - 23:59:59`
        }
      }
    }
  }
};
</script>
<style>
.createResult .el-form .form-timer-picker .el-form-item__content {
  margin-left: 16px !important;
}
</style>
<style lang="less" scoped>
.business-content-main {
  height: 100%;
  overflow: hidden;
}
.scroll-view {
  height: 100%;
  padding-right: 24px;
  overflow-y: scroll;
}
.bread-nav {
  align-items: center;
  justify-content: space-between;
}
.createResult {
  position: relative;
  height: 100%;
}

.quill-editor {
  height: 200px;
}
.pj-cover {
  width: 90px;
  height: 80px;
  // margin-right: 10px;
}
.pj-item {
  display: flex;
  position: relative;
  padding: 10px;
  .jj {
    display: flex;
    align-items: center;
    width: 150px;
    line-height: 1.2em;
    flex-grow: 1;
  }
}
.remove-pj {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  font-size: 25px;
  color: @font3Color;
  cursor: pointer;
}
.pj-input-ctn {
  padding: 0 5px;
  text-align: center;
  flex-grow: 1;
  input {
    padding-right: 0;
    width: 100px;
    line-height: 24px;
    border-radius: 5px;
    border: 1px solid @border1Color;
  }
}
.border-right {
  border-right: 1px solid @border1Color;
}
.pj-list {
  padding-bottom: 20px;
}
.ops-ctn {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-left: 150px;
  z-index: 1;
}
.money-msg {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
.money-item {
  width: 182px;
  display: flex;
  justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
  .key {
    flex-shrink: 0;
  }
}
.all-money {
  color: red;
}
</style>
<style lang="less">
.pj-input-ctn {
  input {
    padding-right: 0;
  }
}
.uploadFile {
  .el-upload--picture-card {
    width: 92px;
    height: 82px;
    line-height: 82px;
    margin-right: 10px;
  }
}
</style>
